import React from 'react';
import { FileText } from 'lucide-react';
import { SEO } from '../../components/SEO';

function UvjetiKoristenja() {
  return (
    <>
      <SEO 
        title="Uvjeti Korištenja | Online Kalkulator"
        description="Uvjeti korištenja Online Kalkulatora. Saznajte više o pravilima korištenja naše web stranice i usluga."
        canonicalUrl="/uvjeti-koristenja"
      />
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-6">
          <FileText className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold text-gray-800 text-center">Uvjeti Korištenja</h1>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">
              Posljednje ažuriranje: {new Date().toLocaleDateString('hr-HR')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Prihvaćanje Uvjeta</h2>
              <p className="text-gray-600">
                Pristupom i korištenjem web stranice Online Kalkulator prihvaćate i slažete se biti
                vezani ovim Uvjetima korištenja. Ako se ne slažete s bilo kojim dijelom ovih uvjeta,
                molimo vas da ne koristite našu web stranicu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Korištenje Usluga</h2>
              <p className="text-gray-600 mb-4">
                Naše usluge možete koristiti samo u zakonite svrhe i u skladu s ovim Uvjetima. Slažete se da nećete:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Koristiti uslugu na bilo koji način koji bi mogao oštetiti, onemogućiti ili preopteretiti sustav</li>
                <li>Koristiti automatizirane skripte za pristup usluzi</li>
                <li>Kopirati ili reproducirati sadržaj bez izričitog dopuštenja</li>
                <li>Koristiti uslugu u nezakonite svrhe</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Točnost Izračuna</h2>
              <p className="text-gray-600">
                Iako se trudimo osigurati točnost svih kalkulatora na našoj web stranici, ne možemo
                jamčiti apsolutnu točnost rezultata. Kalkulatori su namijenjeni samo za informativne
                svrhe i ne bi se trebali koristiti kao zamjena za profesionalni savjet.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Intelektualno Vlasništvo</h2>
              <p className="text-gray-600">
                Sav sadržaj na web stranici, uključujući ali ne ograničavajući se na tekst, grafike,
                logotipe, ikone, slike, audio isječke, digitalna preuzimanja i softver, je vlasništvo
                Online Kalkulatora ili njegovih davatelja sadržaja i zaštićen je zakonima o autorskim
                pravima.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Oglašavanje i Google AdSense</h2>
              <p className="text-gray-600 mb-4">
                Naša web stranica koristi Google AdSense za prikazivanje oglasa. Oglasi se prikazuju na temelju vaših prethodnih aktivnosti na internetu, uključujući posjećene web stranice i klikove na oglase.
              </p>
              <p className="text-gray-600 mb-4">
                Google i njegovi partneri koriste kolačiće za prikazivanje oglasa na temelju vaših prethodnih posjeta našoj web stranici i drugim web stranicama. Korištenjem naše web stranice pristajete na korištenje kolačića za oglašavanje.
              </p>
              <p className="text-gray-600">
                Možete onemogućiti personalizirano oglašavanje posjetom <a href="https://www.google.com/settings/ads" target="_blank" rel="nofollow noopener noreferrer" className="text-blue-600 hover:underline">Google postavki oglasa</a>. Također, možete posjetiti <a href="https://www.aboutads.info/" target="_blank" rel="nofollow noopener noreferrer" className="text-blue-600 hover:underline">www.aboutads.info</a> za više informacija o personaliziranom oglašavanju i vašim mogućnostima isključivanja.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Ograničenje Odgovornosti</h2>
              <p className="text-gray-600">
                Online Kalkulator ne preuzima odgovornost za bilo kakvu štetu koja može nastati
                korištenjem ili nemogućnošću korištenja naših usluga. Sve kalkulacije su informativne
                prirode i ne predstavljaju profesionalni savjet.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Izmjene Uvjeta</h2>
              <p className="text-gray-600">
                Zadržavamo pravo izmjene ovih Uvjeta korištenja u bilo kojem trenutku. Nastavak
                korištenja web stranice nakon objave izmjena smatra se prihvaćanjem novih uvjeta.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Prekid Usluge</h2>
              <p className="text-gray-600">
                Zadržavamo pravo prekida pružanja usluge bilo kojem korisniku, s razlogom ili bez
                njega, u bilo kojem trenutku. Obavijest o prekidu može, ali ne mora biti dana unaprijed.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Kontakt</h2>
              <p className="text-gray-600">
                Ako imate pitanja o ovim Uvjetima korištenja, možete nas kontaktirati:
              </p>
              <ul className="list-disc list-inside text-gray-600 mt-4">
                <li>E-poštom: kontakt@backspace-media.com</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default UvjetiKoristenja;